module.exports = __webpack_public_path__ + "img/GAME_COLORDRAW.1bc91630.jpg";